import React from "react";

const Portfolios = () => {
  return <div>Portfolios</div>;
};

export default Portfolios;
